<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('document')">
            <app-default-button
                v-if="$can('create_document_type')"
                :url="'/document/type'"
                :title="$t('type')"
                btn-class="btn btn-primary mr-2"
            />
            <app-default-button
                :title="$fieldTitle('add', 'document', true)"
                v-if="$can('create_document_file')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="document-file-table"
            :options="options"
            @action="triggerActions"
        />

        <app-document-file-modal
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('document-file-table')"
            @cancelled="cancelled"
        />
    </div>
</template>
<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import DocumentFileMixins from "../../../Mixins/DocumentFileMixins";
import {DOCUMENT_FILE} from "../../../../Config/ApiUrl";

export default {
    name  : "AppDocumentFile",
    mixins: [HelperMixin, DocumentFileMixins],
    data() {
        return {
            isModalActive: false,
            selectedUrl  : '',
        }
    },

    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${DOCUMENT_FILE}/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },

        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    },
}
</script>
